export default {"src":"/_next/static/media/marker-selected.f8658ba1.svg","height":55,"width":39,"blurWidth":0,"blurHeight":0};